import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Practitioners from "@/pages/Practitioners";
import PractitionerDetail from "@/pages/PractitionerDetail";
import Credentials from "@/pages/Credentials";
import UploadOCR from "@/pages/UploadOCR";
import Committee from "@/pages/Committee";
import Compliance from "@/pages/Compliance";
import Settings from "@/pages/Settings";
import Reminders from "@/pages/Reminders";
import HipaaCompliance from "@/pages/HipaaCompliance";
import MyFile from "@/pages/MyFile";
import AppLayout from "@/components/AppLayout";
import IdleTimeout from "@/components/IdleTimeout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-sm text-gray-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function StaffOnly({ children }) {
  const { user } = useAuth();
  if (user?.role === "practitioner") return <Navigate to="/my-file" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <IdleTimeout />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<StaffOnly><Dashboard /></StaffOnly>} />
              <Route path="practitioners" element={<StaffOnly><Practitioners /></StaffOnly>} />
              <Route path="practitioners/:id" element={<StaffOnly><PractitionerDetail /></StaffOnly>} />
              <Route path="credentials" element={<StaffOnly><Credentials /></StaffOnly>} />
              <Route path="upload" element={<StaffOnly><UploadOCR /></StaffOnly>} />
              <Route path="committee" element={<StaffOnly><Committee /></StaffOnly>} />
              <Route path="compliance" element={<StaffOnly><Compliance /></StaffOnly>} />
              <Route path="reminders" element={<StaffOnly><Reminders /></StaffOnly>} />
              <Route path="hipaa" element={<StaffOnly><HipaaCompliance /></StaffOnly>} />
              <Route path="settings" element={<StaffOnly><Settings /></StaffOnly>} />
              <Route path="my-file" element={<MyFile />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
